var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adjustPageTwo"},[_c('div',{staticClass:"box",on:{"click":_vm.toAdjust}},[_c('div',{staticClass:"btn"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }